import { convertFieldValueAvroToJson } from 'rpc-client-utils';

/**
 * Converts CHIRP FieldValue objects inside another object to standard nestedfield values
 * @param chirpFieldValueObject - The object with CHIRP FieldValue objects
 * @returns A new object with converted field values
 */
export const convertChirpFieldValueObjectToJson = chirpFieldValueObject => {
  const convertedStyles = {};
  Object.keys(chirpFieldValueObject).forEach(key => {
    convertedStyles[key] = convertFieldValueAvroToJson(chirpFieldValueObject[key]);
  });
  return convertedStyles;
};